import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTags, faPlus } from '@fortawesome/free-solid-svg-icons';
import { classNames } from '@framework/utils';
import { DarkTooltip } from '@framework/ui/atoms/Tooltip';
import { useTranslation } from 'react-i18next';

type Props = {
  onAddNewTag: () => void;
  disabled: boolean;
};

export const NewViewModelTagIcon: React.FC<Props> = ({ onAddNewTag, disabled }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="rounded-lg bg-white shadow-lg">
      <DarkTooltip
        tooltip={disabled ? t('viewModel.tag.add.maxReached') : t('viewModel.tag.add.tooltip')}
        placement="bottom"
      >
        <button
          className={classNames(
            'cursor-pointer rounded-lg',
            disabled ? 'text-gray-500' : 'text-gray-700 hover:bg-gray-200'
          )}
          onClick={onAddNewTag}
          disabled={disabled}
        >
          <div className="pointer-events-auto flex gap-1 py-2 pl-3 pr-2">
            <div>
              <FontAwesomeIcon icon={faTags} />
            </div>
            <div>
              <FontAwesomeIcon icon={faPlus} />
            </div>
          </div>
        </button>
      </DarkTooltip>
    </div>
  );
};
